import { normalizeListChildren, normalizeListItemChildren, normalizeListItemTextChildren, normalizeOrphanListItem, normalizeOrphanListItemText, normalizeOrphanNestedList, normalizeSiblingLists } from "./normalizations/index.js";
var LIST_NORMALIZERS = [normalizeListChildren, normalizeListItemChildren, normalizeListItemTextChildren, normalizeOrphanListItem, normalizeOrphanListItemText, normalizeOrphanNestedList, normalizeSiblingLists];

/**
 * Enables normalizations that enforce schema constraints and recover from unsupported cases.
 */
export function withLists(schema) {
  return function (editor) {
    var listsEditor = Object.assign(editor, {
      isConvertibleToListTextNode: schema.isConvertibleToListTextNode,
      isDefaultTextNode: schema.isDefaultTextNode,
      isListNode: schema.isListNode,
      isListItemNode: schema.isListItemNode,
      isListItemTextNode: schema.isListItemTextNode,
      createDefaultTextNode: schema.createDefaultTextNode,
      createListNode: schema.createListNode,
      createListItemNode: schema.createListItemNode,
      createListItemTextNode: schema.createListItemTextNode
    });
    return withNormalizations(listsEditor, LIST_NORMALIZERS);
  };
}
function withNormalizations(editor, normalizers) {
  var {
    normalizeNode
  } = editor;
  editor.normalizeNode = entry => {
    for (var normalize of normalizers) {
      var changed = normalize(editor, entry);
      if (changed) {
        return;
      }
    }
    normalizeNode(entry);
  };
  return editor;
}